
import barba from '@barba/core';
import anime from 'animejs';

export default class{

	constructor(){
        barba.hooks.beforeOnce(() => {
            this.videoSwitch()
        })
        barba.hooks.afterOnce(() => {
            this.intro()
        });
        barba.hooks.enter(() => {
            this.videoSwitch()
        })
        barba.hooks.after(() => {
            this.intro()
        });
    }
    
    intro (){
        const timeline = anime.timeline()
        timeline
        .add({
            targets:".l-hero--catch",
            opacity:[0,1],
            duration:1000,
            easing:"easeInOutSine"
        })
        .add({
            targets:".l-hero--catch__ja .rect-g rect",
            width: (el,i) => {
                let w = el.getAttribute("width");
                return [0,w];
            },
            duration:1200,
            easing:"easeInOutExpo",
            delay: (el,i) => {
                return i * 200
            }
        })
        .add({
            targets:".l-hero--catch__ja .st1-g",
            opacity:[0,1],
            duration:1700,
            easing:"easeInOutSine",
            delay: (el,i) => {
                return i * 50
            } 
        },"-=800")
        // .add({
        //     targets:[".l-hero--catch__ja",".l-hero--catch__ja svg"],
        //     marginLeft:0,
        //     left:0,
        //     duration:1500,
        //     easing:"easeInOutExpo"
        // })
        .add({
            targets:".l-hero--catch__ja .st0-g",
            opacity:[0,1],
            duration:400,
            easing:"easeInOutSine",
            delay: (el,i) => {
                return i * 50
            } 
        },"-=1400")
        .add({
            targets:".l-hero--catch__en",
            opacity:[0,1],
            duration:1000,
            easing:"easeInOutSine",
            delay: (el,i) => {
                return i * 200
            }
        },"-=600")
    }
    videoSwitch(){
        const movie = document.querySelector('#l-movie video')
        if(movie){
            if(this._ua.Mobile||this._ua.Tablet){
                movie.setAttribute('src',movie.getAttribute('data-sp'))
            }else{
                movie.setAttribute('src',movie.getAttribute('data-pc'))

            }
        }
    }
    _ua (u){
        return {
            
            Tablet:(u.indexOf("windows") != -1 && u.indexOf("touch") != -1 && u.indexOf("tablet pc") == -1) 
            || u.indexOf("ipad") != -1
            || (u.indexOf("android") != -1 && u.indexOf("mobile") == -1)
            || (u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1)
            || u.indexOf("kindle") != -1
            || u.indexOf("silk") != -1
            || u.indexOf("playbook") != -1
            || u.indexOf('macintosh') > -1 && 'ontouchend' in document,
            Mobile:(u.indexOf("windows") != -1 && u.indexOf("phone") != -1)
            || u.indexOf("iphone") != -1
            || u.indexOf("ipod") != -1
            || (u.indexOf("android") != -1 && u.indexOf("mobile") != -1)
            || (u.indexOf("firefox") != -1 && u.indexOf("mobile") != -1)
            || u.indexOf("blackberry") != -1,
            Safari : (u.indexOf('safari') != -1)
        }
    }
}